var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "has-logo": _vm.showLogo } },
    [
      _vm.showLogo
        ? _c("logo", { attrs: { collapse: _vm.isCollapse } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-scrollbar",
        { attrs: { "wrap-class": "scrollbar-wrapper myMenu" } },
        [
          _c(
            "el-menu",
            {
              ref: "menuEL",
              attrs: {
                "default-active": _vm.activeMenu,
                "default-openeds": _vm.defaultOpen,
                collapse: _vm.isCollapse,
                "background-color": _vm.variables.menuBg,
                "text-color": _vm.variables.menuText,
                "unique-opened": false,
                "active-text-color": _vm.variables.menuActiveText,
                "collapse-transition": false,
                mode: "vertical",
              },
              on: { close: _vm.closeMenuAction },
            },
            _vm._l(_vm.menuList, function (route) {
              return _c("sidebar-item", {
                key: route.route,
                attrs: { item: route, "base-path": route.route },
              })
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }